var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.748 4.68652C10.9524 4.68652 10.1893 5.00259 9.62673 5.5652C9.06412 6.12781 8.74805 6.89087 8.74805 7.68652C8.74805 8.48217 9.06412 9.24524 9.62673 9.80784C10.1893 10.3705 10.9524 10.6865 11.748 10.6865C12.5437 10.6865 13.3068 10.3705 13.8694 9.80784C14.432 9.24524 14.748 8.48217 14.748 7.68652C14.748 6.89087 14.432 6.12781 13.8694 5.5652C13.3068 5.00259 12.5437 4.68652 11.748 4.68652ZM11.748 12.6865C10.422 12.6865 9.1502 12.1597 8.21251 11.2221C7.27483 10.2844 6.74805 9.01261 6.74805 7.68652C6.74805 6.36044 7.27483 5.08867 8.21251 4.15099C9.1502 3.21331 10.422 2.68652 11.748 2.68652C13.0741 2.68652 14.3459 3.21331 15.2836 4.15099C16.2213 5.08867 16.748 6.36044 16.748 7.68652C16.748 9.01261 16.2213 10.2844 15.2836 11.2221C14.3459 12.1597 13.0741 12.6865 11.748 12.6865ZM11.748 0.186523C6.74805 0.186523 2.47805 3.29652 0.748047 7.68652C2.47805 12.0765 6.74805 15.1865 11.748 15.1865C16.748 15.1865 21.018 12.0765 22.748 7.68652C21.018 3.29652 16.748 0.186523 11.748 0.186523Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye-icon.c40eb18472e2a90b418dbb3638e0d7d8.svg";
export { ForwardRef as ReactComponent };